import React from 'react';
import {
  BaseComponentProps,
  useComponentData,
  useSkeletonHelper,
} from '../helpers/contentHooks';
import { ClickableComponentLayout } from '../layouts/ClickableComponentLayout';
import { Skeleton } from 'antd';
import { MediaHelpers } from '@wajeez-web/core/api';

interface CategoriesLargeListParameters {
  title: string | null;
  seeAllTitle: string | null;
}

export function CategoriesGrid({
  component,
  context,
  isLastSibling,
}: BaseComponentProps) {
  const { getParameterValue, contents, contentsRequestStatus } =
    useComponentData<CategoriesLargeListParameters>(component, context);

  const { isActive } = useSkeletonHelper(
    contentsRequestStatus,
    contents?.length ? true : false
  );

  const title = getParameterValue('title');

  return contentsRequestStatus !== 'loading' &&
    contentsRequestStatus !== 'failed' &&
    contents?.length ? (
    <div className="space-y-[17px] ">
      <div className="flex justify-between px-4 sm:px-0">
        <div className=" font-bold text-[20px] sm:text-[18px] sm:text-[#27160E]">
          {title}
        </div>
      </div>
      <div>
        <div
          className={`w-full ${
            !isLastSibling && 'border-b-[0.5px]'
          } border-[#C6C6C8] dark:border-dark-divider sm:border-none`}
        >
          <div className="flex overflow-x-auto scrollbar-none">
            <div className={`flex flex-nowrap flex-row space-s-3 `}>
              {contents?.map((content, i) => {
                return (
                  <RepeatedCtegoriesItem
                    key={content.id}
                    component={{ ...component?.itemTemplate, uniqueId: i }}
                    context={content}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (contentsRequestStatus === 'loading' ||
      contentsRequestStatus === 'failed') &&
    !contents?.length ? (
    <CategoriesLargeListSkeleton
      isLastSibling={isLastSibling}
      isActive={isActive}
    />
  ) : null;
}

const CategoriesLargeListSkeleton = ({
  isLastSibling,
  isActive = true,
  hasTitle = true,
  sliderCustomStyle,
  shape = 'round',
}: {
  isLastSibling: boolean | 0 | undefined;
  isActive?: boolean;
  hasTitle?: boolean;
  sliderCustomStyle?: string;
  shape?: 'circle' | 'round' | 'square' | 'default' | undefined;
}) => {
  return (
    <div className="w-full pr-2 sm:pr-0">
      {hasTitle && (
        <Skeleton
          active={isActive}
          paragraph={{ rows: 0 }}
          className="pr-2 sm:pr-0"
        />
      )}
      <div
        className={`w-full ${
          !isLastSibling && 'border-b-[0.5px]'
        } border-[#C6C6C8] dark:border-dark-divider sm:border-none`}
      >
        <div className="flex overflow-x-auto scrollbar-none px-2 sm:px-0">
          <div
            className={`flex flex-nowrap flex-row space-s-2 sm:space-s-6 px-2 sm:px-0 !pb-0`}
          >
            {Array.from({ length: 10 }).map((_, i) => {
              return (
                <Skeleton.Button
                  key={i}
                  active={isActive}
                  shape={shape}
                  block={true}
                  className="!w-[90px] sm:!h-[36px] sm:!rounded-[10px]"
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

interface CategoriesLargeListItemParameters {
  backgroundImage: string | null;
  icon: string | null;
}

export const RepeatedCtegoriesItem: React.FC<BaseComponentProps> = ({
  component,
  context,
}) => {
  const { getParameterValue, content } =
    useComponentData<CategoriesLargeListItemParameters>(component, context);

  const icon = getParameterValue('icon');

  return (
    <ClickableComponentLayout content={content}>
      <div className="flex space-s-2 flex-nowrap  items-center py-[6px] px-3 rounded-xl bg-[#F2F2F6] border border-primary dark:border-primary-dark text-primary dark:text-primary-dark dark:bg-[#1C1C1E]">
        <div
          className={` h-[34px] w-[34px]  flex justify-center items-center   `}
        >
          <img
            src={MediaHelpers.getPublicMediaById(icon)}
            alt=""
            className="h-[31px] w-[31px]"
          />
        </div>
        <div className="text-[15px] whitespace-nowrap inline-block w-fit">
          {content?.title}
        </div>
      </div>
    </ClickableComponentLayout>
  );
};
